const filterUbication = ({ ubications, isEditFilter, idUbicationToDelete }) => {
  if (isEditFilter) {
    const temporal = ubications.map((location) => {
      if (location.id !== idUbicationToDelete) return location;

      return { ...location, eliminarUbicacion: true };
    });

    return temporal;
  }

  const temporal = ubications.filter((location) => location.id !== idUbicationToDelete);

  return temporal;
};

const updateLocationData = ({
  ubications,
  ubicationIndex,
  positionNumber,
  lineNumber,
  isEdit,
  plIndex
}) => {
  const ubicationToReturn = ubications;

  // Busco la posicion y linea y modifico el atributo
  if (isEdit) {
    ubicationToReturn[ubicationIndex].posLines[plIndex].eliminarPosicionLinea = true;

    return ubicationToReturn;
  }

  ubicationToReturn[ubicationIndex].posLines = ubicationToReturn[ubicationIndex].posLines.filter(
    (positionLine) =>
      !(positionLine.numeroLinea === lineNumber && positionLine.numeroPosicion === positionNumber)
  );

  return ubicationToReturn;
};

const getIndexUbiaction = ({ ubications, values }) =>
  ubications.findIndex((loc) => {
    if (loc.isOyM) {
      return (
        loc.nombre === values?.ubication?.ubication?.nombre &&
        loc.idOperacion === values?.ubication?.uunn?.id &&
        loc.ubicacionTecnica?.idInstalacion === values?.ubication?.installation?.id
      );
    }

    // todo: ver que pasa ubicaciones eym con distinto eventoPozoId y distinto equipo, pero resto de data igual
    return (
      loc.nombre === values?.ubication?.ubication?.nombre &&
      loc.idUnidadNegocio === values?.ubication?.uunn?.id &&
      loc.tipoUbicacionEnum === values?.ubication?.ubicationType?.id &&
      loc.idEvento === values?.ubication?.event?.id &&
      loc.idLocacion === values?.ubication?.ubication?.id
    );
  });

const addPosLinesWithOutRepetition = ({ currentPosLines, newPosLines }) => {
  const posLines = currentPosLines.concat(newPosLines);

  const positionLineMap = new Map(
    posLines.map((posLine) => [`${posLine.numeroPosicion}-${posLine.numeroLinea}`, posLine])
  );

  const posLinesWithOutRepetition = Array.from(positionLineMap, ([_, value]) => value);

  return posLinesWithOutRepetition;
};

export { filterUbication, updateLocationData, getIndexUbiaction, addPosLinesWithOutRepetition };
